import React, { createContext, useContext, useEffect, useState } from "react";
import { URL } from "../helper/Mainurl";
import { useAuth } from "./AuthContext";
const SubscriptionsContext = createContext();

export const useSubscriptions = () => useContext(SubscriptionsContext);

export const SubscriptionsProvider = ({ children }) => {
  const { authData } = useAuth();
  const [subscriptions, setSubscriptions] = useState([]);
  const [purchasedSubscription, setPurchasedSubscription] = useState(null);
  const [isCoParent, setIsCoparent] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchSubscriptions = async () => {
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("authToken");
    try {
      const response = await fetch(`${URL}/v1/user/subscription`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error("Failed to fetch subscriptions");
      const result = await response.json();
      const subs = result?.data?.subscriptions || [];
      const purchased = subs.find((sub) => sub.is_purchased === true) || null;
      // Map to include 'isPurchased' property for convenience
      setSubscriptions(
        subs.map((sub) => ({
          ...sub,
          isPurchased: !!sub.is_purchased,
        }))
      );
      setPurchasedSubscription(purchased);
      if (result?.data?.coparent_relationships) {
        setIsCoparent(true);
      }
    } catch (err) {
      setError(err.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, [authData]);

  useEffect(() => {
    if (!purchasedSubscription?.services) return;

    const hasCoParentingFeature = purchasedSubscription.services.some(
      (service) =>
        service.name ===
        "Co-Parenting Calendar (shared child \narrangement tools)"
    );

    if (
      !hasCoParentingFeature &&
      localStorage.getItem("hasInvitesBeenSent") === "true"
    ) {
      localStorage.removeItem("hasInvitesBeenSent");
    }
  }, [purchasedSubscription]);

  return (
    <SubscriptionsContext.Provider
      value={{
        subscriptions,
        loading,
        error,
        purchasedSubscription,
        fetchSubscriptions,
        isCoParent,
      }}
    >
      {children}
    </SubscriptionsContext.Provider>
  );
};
